<script>
import RecycleModal from './RecycleModal.vue'
import FailModal from './FailModal.vue'
import _ from 'lodash'
import moment from "moment";

export default {
    components: {
        RecycleModal,
        FailModal,
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        logs: {
            type: Object,
            required: false
        },
        sageLog: {
            type: Object,
            required: false
        },
    },

    data() {
        return {
            average: 0,
            rating: [],
            fail_reason: ''
        }
    },
    computed: {
        startStatus() {
            if (this.jobApplication.job_start_result) {
                return _.startCase((this.jobApplication.job_start_result.status === 'reschedule') ? 'The candidate is not available.  Please resend a new invitation.' : this.jobApplication.job_start_result.status)
            } else {
                return "Not yet set"
            }
        }
    },
    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        fail(fail_reason) {
            this.fail_reason = fail_reason
            this.$nextTick(() => {
                this.$refs.failedButton.click();
            });
        },
        scheduleDate(date) {
            return moment(new Date(date)).format("LLLL");
        },
        convertDate(date, format = 'YYYY-MM-DD HH:mm') {
            return moment.parseZone(date).format(format)
        },
        parseSageResponse(json) {
            try {
                return JSON.parse(json);
            } catch (e) {
                return false;
            }
        }
    }
}
</script>

<template>
    <div class="telephonic-screening px-4 pt-3 pb-5">
        <form method="post" class="pt-0">
            <div>
                <input type="hidden" name="_csrfToken" :value="csrfToken" />
                <input type="hidden" name="fail_reason" :value="fail_reason" />
                <div>
                    <p>Start date scheduled for: <span class="fw-bold" v-if="jobApplication.job_start_result && jobApplication.job_start_result.start_datetime">{{ scheduleDate(jobApplication.job_start_result.start_datetime) }}</span></p>
                    <p class="mb-2">Current Status: <strong>{{ startStatus }}</strong>
                        <span v-if="logs !== null && logs !== ''">
                            &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created, 'YYYY-MM-DD HH:ss') }})
                        </span>
                    </p>
                    <strong>Did the candidate start working following their onboarding session?</strong>
                </div>
            </div>
            <div class="grid-x grid-padding-x" v-if="jobApplication.job_start_result">
                <div class="cell large-6 pe-5" style="border-right: solid 1px #D1D1D1;">
                    <div class="d-flex align-items-start gap-4">
                        <button 
                            class="button mt-4" 
                            type="submit" 
                            name="job_start_result[status]"
                            value="pass"
                        >YES - PROCEED TO START</button>
                        <div>
                            <button class="button secondary-btn mt-4" type="submit" name="job_start_result[status]"
                                value="explain">NO - ASK CANDIDATE FOR
                                EXPLANATION</button>
                            <button class="button secondary-btn mt-2" type="submit"
                                name="job_start_result[status]" value="reschedule">NO - RESCHEDULE
                                ONBOARDING</button>
                            <button class="button secondary-btn mt-2" type="button" name="job_start_result[status]"
                                value="recycle" @click="toggleModal('recycleModal')">NO - RECYCLE CANDIDATE</button>

                            <button class="d-none" value="fail" ref="failedButton"
                                name="job_start_result[status]"></button>
                            <button class="button alert mt-2" type="button" name="job_start_result[status]" value="recycle"
                                @click="toggleModal('failModal')">NO - DECLINE CANDIDATE</button>
                        </div>
                    </div>
                </div>
                <div class="cell large-6 px-4">
                    <div class="small-12">
                        <label class="fw-bold">Reason(s) for candidate not showing up:</label><br>
                        {{ jobApplication.job_start_result.explanation }}
                    </div>

                    <div v-if="sageLog" class="small-12 mt-5">
                        <label class="fw-bold">Sage sync status:</label><br>
                        <span v-if="sageLog.completed" class="text-green">Synced</span>
                        <span v-if="!sageLog.completed && sageLog.failed > 0" class="text-red">Failed</span>

                        <div v-if="!sageLog.completed && sageLog.failed > 0 && sageLog.log_entries[0]" class="mt-4">
                            <label class="fw-bold">Parsed Sage Response:</label><br>
                            <ul>
                                <li v-for="rule in parseSageResponse('{' + sageLog.log_entries[0].response_data.split('{').slice(1).join('{')).businessRules" :key="rule.PropertyName">
                                    {{ rule.PropertyFriendlyName }}
                                    <ul v-if="rule.WarningRulesCollection">
                                        <li v-for="message in rule.WarningRulesCollection" :key="message">
                                            {{ message.Message }}
                                        </li>
                                    </ul>

                                    <ul v-if="rule.ErrorRulesCollection">
                                        <li v-for="message in rule.ErrorRulesCollection" :key="message">
                                            {{ message.Message }}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <br/>
                            <label class="fw-bold">Error Response:</label><br>

                            <div v-if="sageLog.log_entries[0].response_data.includes('{')">
                                {{ '{' + sageLog.log_entries[0].response_data.split('{').slice(1).join('{') }}
                            </div>
                            <div v-else>
                                <pre>{{ sageLog.log_entries[0].response_data }}</pre>
                            </div>

                            <div>
                                <label class="fw-bold">Payload Sent:</label><br>
                                <pre>{{ sageLog.log_entries[0].request_data }}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                No starting scheduled
            </div>
        </form>

        <recycle-modal ref="recycleModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        <fail-modal ref="failModal" :job-application="jobApplication" @submit="fail" />
    </div>
</template>

<style scoped>
.button {
    font-size: 11px !important;
    text-align: left;
}

.secondary-btn {
    background-color: #979797;
}
</style>